module.exports = __webpack_public_path__ + "img/RAInvert.7d2bda53.png";